import React from 'react';
import { injectGlobal } from 'styled-components';
import { AuthCard, Card } from 'ts/components/Card';
import { Heading } from 'ts/components/Heading';
import { RegisterBlock } from '../RegisterBlock/RegisterBlock';
import { IError } from 'ts/login/interfaces';
import { ExperienceProvider, ExperienceSelector } from '@origin-digital/features';
import { NextBestAction } from '@origin-digital/personalisation';
import { Page } from '../../../components/Page';
import { CaptchaDisclaimer } from '../CaptchaDisclaimer';
import { LoginErrorBox } from '../LoginErrorBox';
import { LoginView } from './LoginView';
import { Loader } from '../../../components/Loader';

export interface LoginFormActions {
  handleFormSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  handleUsernameOnChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleUsernameOnBlur: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handlePasswordOnChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleRememberMeChange: () => void;
}

interface LoginFormProps {
  checkingUser: boolean;
  disableUsernameIcon: boolean;
  error: IError;
  loading: boolean;
  username: string;
  usernameError: string;
  password: string;
  passwordError: string;
  rememberMe: boolean;
  loginFormActions: LoginFormActions;
}

/* Don't know how or why but a user agent stylesheet font is being applied to button which is causing it
 *  to display at the incorrect font size of 11px. This overrides that and sets font-size to 14px
 */
injectGlobal`
  [class^="CardNBA__CardContainer"] [class^="ButtonSecondarySkin"] {
    font-size: 14px;
  }
`;

export const LoginForm: React.FC<LoginFormProps> = ({
  checkingUser,
  disableUsernameIcon,
  error,
  loading,
  username,
  usernameError,
  password,
  passwordError,
  rememberMe,
  loginFormActions,
}) => {
  return (
    <Page>
      <ExperienceProvider mboxes={['OE-440-mbox']}>
        <ExperienceSelector mbox="OE-440-mbox">
          {(content) =>
            content &&
            content.experienceId && (
              <Card>
                <NextBestAction content={content} />
              </Card>
            )
          }
        </ExperienceSelector>
      </ExperienceProvider>
      <AuthCard>
        <Heading text="Log in to My Account" />
        {loading ? (
          <Loader height="500px" />
        ) : (
          <div>
            <LoginErrorBox error={error} />
            <form onSubmit={loginFormActions.handleFormSubmit} noValidate>
              <LoginView
                handleUsernameOnChange={loginFormActions.handleUsernameOnChange}
                handleUsernameOnBlur={loginFormActions.handleUsernameOnBlur}
                handlePasswordOnChange={loginFormActions.handlePasswordOnChange}
                handleRememberMeChange={loginFormActions.handleRememberMeChange}
                password={password}
                rememberMe={rememberMe}
                username={username}
                checkingUser={checkingUser}
                usernameError={!error && usernameError}
                passwordError={!error && passwordError}
                disableUsernameIcon={disableUsernameIcon}
              />
            </form>
            <RegisterBlock />
            <CaptchaDisclaimer />
          </div>
        )}
      </AuthCard>
    </Page>
  );
};
